import { SendOutlined } from '@ant-design/icons';
import { useFormStateIsDirty } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { AsyncButton } from '@framework/ui';
import { Tooltip } from 'antd';
import * as React from 'react';

export interface ICommunicationSendButtonProps {
  onSend: () => Promise<void>;
}

export function CommunicationSendButton(props: ICommunicationSendButtonProps) {
  const { onSend } = props;
  const { t } = useTranslation();
  const isDirty = useFormStateIsDirty();
  return (
    <Tooltip
      title={
        isDirty
          ? t(
              'comunicazioni.tooltip-salva-prima-di-inviare',
              'Salva la comunicazione prima di inviarla',
            )
          : ''
      }
    >
      <AsyncButton
        size="large"
        disabled={isDirty}
        type="primary"
        onClick={onSend}
        icon={<SendOutlined aria-hidden />}
      >
        {t('comunicazioni.invia', 'Invia')}
      </AsyncButton>
    </Tooltip>
  );
}
